<template>
  <div class="table-widget">
    <table v-if="!loadingVotingSession && votingSessions.length > 0">
      <tr>
        <th>Voting Session</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in votingSessions" :key="index">
        <td>
          <div class="event-info">
            <h6>{{ item.title }}</h6>
            <div class="sponsored-status">
              <b-tag v-if="item.is_sponsored" type="is-info">Sponsored</b-tag>
            </div>
          </div>
        </td>
        <td>
          <div class="event-date">
            {{ moment(item.start_time).format("DD MMM YYYY H:mm:ss") }}
          </div>
        </td>
        <td>
          <div class="event-date">
            {{ moment(item.end_time).format("DD MMM YYYY H:mm:ss") }}
          </div>
        </td>
        <td>
          <div class="event-status">
            <b-tag v-if="item.status == 'pending'" type="is-info" class="status-tag">
              Pending
            </b-tag>
            <b-tag v-if="item.status == 'public'" type="is-success" class="status-tag">
              Published
            </b-tag>
          </div>
        </td>
        <td>
          <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>
            <b-dropdown-item @click="reCalcurateVotingTransations(item)" aria-role="listitem">Recalcurate
              Transations</b-dropdown-item>
            <b-dropdown-item v-if="!item.is_sponsored" @click="setVotingSessionAsSponsored(item, true)"
              aria-role="listitem">Set
              As Sponsored</b-dropdown-item>
            <b-dropdown-item v-if="item.is_sponsored" @click="setVotingSessionAsSponsored(item, false)"
              aria-role="listitem">Remove As Sponsored</b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
    </table>
    <table v-if="loadingVotingSession">
      <tr>
        <th>Event name</th>
        <th>Created Date</th>
        <th>Schedured date</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in 15" :key="index">
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    channel: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    votingSessions: [],
    loadingVotingSession: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAllChannelVottingSessions();
  },
  methods: {
    getAllChannelVottingSessions() {
      let vm = this;
      vm.loadingVotingSession = true;
      vm.$store
        .dispatch("CHANNEL_GET_ALL_VOTING_SESSIONS", { channel_id: vm.channel.id, user_id: vm.channel.user_id })
        .then((response) => {
          vm.loadingVotingSession = false;
          vm.votingSessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loadingVotingSession = false;
        });
    },
    reCalcurateVotingTransations(item) {
      let vm = this;
      vm.$store
        .dispatch("CHANNEL_RECALCULATE_VOTING_TRANSACTIONS", {
          channel_id: vm.channel.id,
          user_id: vm.channel.user_id,
          id: item.id,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "success",
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "danger",
          });
        });
    },
    setVotingSessionAsSponsored(item, status) {
      let vm = this;
      vm.$store
        .dispatch("CHANNEL_SET_ITEM_AS_SPONSORED", {
          type: "voting_session",
          channel_id: vm.channel.id,
          user_id: vm.channel.user_id,
          ref_id: item.id,
          isSponsored: status,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "success",
          });
          vm.getAllChannelVottingSessions();
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "danger",
          });
        });
    }
  },
};
</script>
<style lang="scss" scoped>
  .table-widget {
    // height: calc(100% - 60px);
    overflow-y: auto;
    border-radius: 0;
    button.openButton {
      display: none;
      width: fit-content;
      margin: 5px 0 0 5px;
      @media (max-width: 600px) {
        display: flex;
      }
    }
    table {
      width: 100%;
      tr {
        th {
          white-space: nowrap;
        }
        td {
          white-space: nowrap;
          .tag-lists {
            display: flex;
            width: fit-content;
            flex-shrink: 0;
            min-width: 170px;
          }
        }
      }
    }
  }
</style>

